import Vue from 'vue'

/**
 * @author Jorge Núñez L. <>
 *
 * send rejected quotations 
 */

const sendRejectedQuotations = (payload) =>
  Vue.$http.post(`purchase/reject-consolidated-supply/`, payload)
    .then()
    .catch((err) => { throw err })

export default sendRejectedQuotations


// WEBPACK FOOTER //
// ./src/services/purchase/quotation/sendRejectedQuotations.js